import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { validateOktaConfig } from './config/oktaConfig';
import { Amplify } from 'aws-amplify';
import awsconfig from './aws-exports';

// Configure Amplify with guest (unauthenticated) access
Amplify.configure({
  Auth: {
    Cognito: {
      identityPoolId: awsconfig.aws_cognito_identity_pool_id,
      region: awsconfig.aws_cognito_region,
      allowGuestAccess: true
    }
  },
  Storage: {
    S3: {
      bucket: awsconfig.aws_user_files_s3_bucket,
      region: awsconfig.aws_user_files_s3_bucket_region
    }
  }
});

// Validate Okta configuration on startup
try {
  validateOktaConfig();
} catch (error) {
  console.error('Failed to validate Okta configuration:', error);
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

